import { Uuid } from '../Base';
import Repository, { RepositoryJson } from '../Repository';
import { Post, PostJson } from './Post';

export enum PostListType {
  Recent = 'recent',
}

export enum PostMapType {
  SearchHistory = 'SearchHistory',
}

export type PostMapField = PostMapType;
export type PostListField = string | PostListType;

export class PostRepository extends Repository<
  Post,
  PostJson<Date | number>,
  PostMapField,
  PostListField
> {
  constructor(
    repository?: RepositoryJson<
      PostJson<Date | number>,
      PostMapField,
      PostListField,
      Date | number
    >,
  ) {
    super(
      {
        ...repository,
        listFields: Repository.initFields(repository?.listFields, {
          [PostListType.Recent]: {},
          // Initialize default fields if necessary
        }),
        mapFields: Repository.initFields(repository?.mapFields, {
          [PostMapType.SearchHistory]: {},
        }),
      },
      (x) => new Post(x),
    );
  }
}

export interface PostStoreStateJson {
  posts: RepositoryJson<PostJson, PostMapField, PostListField, number>;
}

export interface PostStoreState {
  posts: PostRepository;
}

export interface PostStoreAction {
  // post actions
  getPost: (postId: Uuid) => Post | null | undefined;

  fetchPost: (postId: Uuid) => Promise<void>;
}
